// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextPlaceholder__container-e71cc6 {
  height: 20px;
  border-radius: 6px;
  display: block;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/TextPlaceholder/TextPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  height: 20px;\n  border-radius: 6px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextPlaceholder__container-e71cc6`
};
module.exports = ___CSS_LOADER_EXPORT___;
